import AuthForm from "@/components/AuthForm";

export default function Register() {
  return <AuthForm mode="register" />;
}
